import React, { createContext, useContext, useState, ReactNode, useCallback } from "react";
import { Dialog } from "primereact/dialog";

interface ModalContextProps {
  showModal: (header: string, content: ReactNode) => void;
  hideModal: () => void;
}

const ModalContext = createContext<ModalContextProps | undefined>(undefined);

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [modalContent, setModalContent] = useState<ReactNode>(null);
  const [modalHeader, setModalHeader] = useState<string>("");

  const showModal = useCallback((header: string, content: ReactNode) => {
    setModalHeader(header);
    setModalContent(content);
    setVisible(true);
  }, []);

  const hideModal = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <ModalContext.Provider value={{ showModal, hideModal }}>
      {children}
      <Dialog
        header={modalHeader}
        visible={visible}
        onHide={hideModal}
        style={{ width: "40vw" }}
        modal
        closeOnEscape
        dismissableMask
      >
        {modalContent}
      </Dialog>
    </ModalContext.Provider>
  );
};

export const useModal = (): ModalContextProps => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
